<template>
  <div style="padding: 24px;height: 1198px;overflow-y: auto">
    <div style="background-color: #fff;border-radius: 8px;margin: 20px 0">
      <el-form label-position="top" class="custom-label-form">
        <el-form-item class="form_item_box" label="">
          <div class="container">
            <div class="label-with-input">
              <span> <span class="redsp">*</span>选择模版 </span>
              <el-select
                v-model="form_data.template_id"
                placeholder="请输入模版名称"
                filterable
                remote
                reserve-keyword
                :remote-method="fetchUserList"
                :clearable="true"
                @focus="handleTemplateSearch"
                @change="handleTemplateChange"
              >
                <el-option
                  v-for="item in template_data"
                  :key="item.id"
                  :label="item.template_name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="label-with-input">
              项目名称
              <el-input v-model="form_data.name" placeholder="请输入" />
            </div>
            <div class="label-with-input">
              广告状态
              <el-radio-group v-model="form_data.opt_status">
                <el-radio-button label="ENABLE">启用</el-radio-button>
                <el-radio-button label="DISABLE">暂停</el-radio-button>
              </el-radio-group>
            </div>
            <div class="label-with-input">
              投放时间
              <el-date-picker
                v-model="scheduleRange"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </div>
            <div class="label-with-input">
              投放产品id
              <el-input v-model="form_data.chameleon_app_id" placeholder="请输入" />
            </div>
            <div class="label-with-input">
              短剧id
              <el-input v-model="form_data.book_id" placeholder="请输入" />
            </div>
            <div class="label-with-input">
              素材来源
              <el-radio-group v-model="form_data.material_source">
                <el-radio-button label="2">变色龙</el-radio-button>
                <el-radio-button label="3">各占一半</el-radio-button>
                <el-radio-button label="4">本地</el-radio-button>
                <el-radio-button label="5">ADX</el-radio-button>
              </el-radio-group>
            </div>
            <div class="label-with-input">
              项目预算
              <el-radio-group v-model="form_data.budget_mode">
                <el-radio-button label="BUDGET_MODE_INFINITE">不限</el-radio-button>
                <el-radio-button label="BUDGET_MODE_DAY">日预算</el-radio-button>
              </el-radio-group>
            </div>
            <div v-if="form_data.budget_mode === 'BUDGET_MODE_DAY'" class="label-with-input">
              预算金额
              <el-input-number v-model="form_data.budget" :max="999999" :min="300" />
            </div>
            <div class="label-with-input">
              出价系数
              <el-input-number v-model="form_data.search_bid_ratio" :min="1" :precision="2" :max="2" :step="0.1" />
            </div>
          </div>
        </el-form-item>
        <div class="line" />
      </el-form>
    </div>
    <div style="background-color: #FFFFFF;border-radius: 8px;height: 80px;align-items: center;display: flex">
      <div class="container" style="">
        <div>
          搭建
          <el-input-number v-model="form_data.project_num" class="custom-input-number" :min="1" :max="50" size="mini" controls-position="right" />
          个项目，每个项目安排
          <el-input-number v-model="form_data.promotion_num" class="custom-input-number" :min="1" size="mini" controls-position="right" />
          个广告，每个广告安排
          <el-input-number v-model="form_data.material_num" class="custom-input-number" :min="1" :max="delivery_mode === 'PROCEDURAL'? 10: 30" size="mini" controls-position="right" />
          个素材。
        </div>
      </div>
    </div>
    <div style="background-color: #FFFFFF;border-radius: 8px;margin-top: 20px;padding: 20px">
      <el-button type="success" @click="showAccountDialog"> 添加账号</el-button>
      <el-table
        :data="form_data.account_param"
        :header-cell-style="{display: 'none'}"
      >
        <!-- 第一列：账号ID（隐藏） -->
        <el-table-column v-if="false" prop="account_id" />

        <!-- 第二列：账号名称 -->
        <el-table-column label="账号">
          <template #default="scope">
            <el-tag>{{ scope.row.account_id }} </el-tag>
          </template>
        </el-table-column>

        <!-- 第三列：应用选择 -->
        <el-table-column label="小程序id">
          <template #default="scope">
            <el-select
              v-model="scope.row.app_id"
              filterable
              remote
              :remote-method="(query) => queryAppSearch(query, scope.row)"
              :loading="appLoading"
              placeholder="请输入小程序名称搜索"
              @focus="handleAppSearch(scope.row)"
              @change="(selectedAppId) => handleAppChange(selectedAppId, scope.row)"
            >
              <el-option
                v-for="item in scope.row.appOptions"
                :key="item.instance_id"
                :label="item.title"
                :value="item.instance_id"
              />
            </el-select>
          </template>
        </el-table-column>

        <!-- 第四列：小程序链接 -->
        <el-table-column label="小程序链接">
          <template #default="scope">
            <el-select
              v-model="scope.row.micro_app_url_id"
              :disabled="!scope.row.micro_app_id"
              filterable
              remote
              :remote-method="(query) => queryLinkSearch(query, scope.row)"
              :loading="linkLoading"
              placeholder="请输入小程序链接名称搜索"
              @focus="handleLinkSearch(scope.row)"
            >
              <el-option
                v-for="item in scope.row.linkOptions"
                :key="item.id"
                :label="item.remark"
                :value="item.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <!--  抖音号      -->
        <el-table-column>
          <template #default="scope">
            <el-select
              v-model="scope.row.aweme_id"
              :loading="linkLoading"
              placeholder="请选择推广身份"
            >
              <el-option
                v-for="item in scope.row.DouYinOptions"
                :key="item.aweme_id"
                :label="item.aweme_name"
                :value="item.aweme_id"
              />
            </el-select>
          </template>
        </el-table-column>
        <!--  落地页      -->
        <el-table-column>
          <template #default="scope">
            <el-select
              v-model="scope.row.site_url"
              :disabled="!form_data.template_id"
              filterable
              remote
              :remote-method="(query) => queryLoDiYeSearch(query, scope.row)"
              :loading="linkLoading"
              placeholder="请选择落地页"
              @focus="handleLuoDiSearch(scope.row)"
            >
              <el-option
                v-for="item in scope.row.LuoDiOptions"
                :key="item.url"
                :label="item.site_id"
                :value="item.url"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <span class="action-btn" style="color: #F53F3F" @click="handleClose(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="background-color: #FFFFFF;border-radius: 8px;height: 80px;" class="button-box-itemfoot">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button type="info">取消</el-button>
    </div>
    <el-dialog title="选择账号" :visible.sync="accountDialogVisible" width="1200px">
      <account ref="account" :account_list="all_accounts" @commit="addAccountList" @close="accountDialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import { adTemplateList, iseAccount, microApp, SetUpJobCreate, siteList } from '@/api/customer'
import { copyv2urllist } from '@/api/massiveAdvertising/accountList'
import Account from '@/views/backhaul/components/account.vue'

export default {
  components: { Account },
  data() {
    return {
      staticRules: {
      },
      formErrors: {},
      delivery_mode: 'PROCEDURAL',
      form_data: {
        budget_mode: 'BUDGET_MODE_DAY',
        budget: null,
        start_time: null,
        end_time: null,
        opt_status: 'ENABLE',
        promotion_num: 0,
        material_num: 0,
        project_num: 0,
        account_param: [],
        name: null,
        chameleon_app_id: null,
        search_bid_ratio: null,
        book_id: null,
        material_source: 2,
        template_id: null
      },
      id: null,
      template_query: {
        page: 1,
        page_size: 10,
        name: null
      },
      template_data: [],
      accountDialogVisible: false,
      selectedAccounts: [],
      appLoading: false,
      linkLoading: false,
      linkOptions: [], // 链接搜索选项
      account_data: {
        list: [],
        total: 0
      },
      all_accounts: []
    }
  },
  computed: {
    finalRules() {
      const rules = { ...this.staticRules }

      if (this.form_data.budget_mode !== 'BUDGET_MODE_INFINITE') {
        rules.budget = this.staticRules.budget
      } else {
        rules.budget = [] // 不需要校验
      }
      return rules
    },
    scheduleRange: {
      get() {
        return this.form_data.start_time && this.form_data.end_time ? [this.form_data.start_time, this.form_data.end_time] : []
      },
      set(val) {
        if (Array.isArray(val)) {
          this.form_data.start_time = val[0] || ''
          this.form_data.end_time = val[1] || ''
        }
      }
    }
  },
  methods: {
    validateField(field) {
      console.log(field)
      const value = this.form_data[field]
      const fieldRules = this.finalRules[field]
      if (fieldRules && Array.isArray(fieldRules)) {
        for (const rule of fieldRules) {
          const result = rule(value)
          if (result !== true) {
            this.$set(this.formErrors, field, result)
            return
          }
        }
      }
      this.$delete(this.formErrors, field)
    },

    validateAll() {
      Object.keys(this.finalRules).forEach(field => {
        this.validateField(field)
      })
      return Object.keys(this.formErrors).length === 0
    },
    onSubmit() {
      console.log(this.form_data)
      if (!this.validateAll()) {
        console.log(this.formErrors)
        return this.$message.error('请填写完善信息')
      }
      console.log(this.form_data.account_param)
      console.log(this.form_data)
      SetUpJobCreate(this.form_data).then(res => {
        console.log(res)
        if (res.code === 0) {
          // this.$router.push('/massiveAdvertisingAD/AdvertisingJob/index')
          this.$message.success('添加成功')
        }
      })
    },
    fetchUserList(query) {
      console.log(query)
      if (query) {
        this.template_query.name = query
      }
      this.loading = true
      this.list()
    },
    list() {
      adTemplateList(this.template_query).then(res => {
        this.template_data = res.data.list
      })
    },
    handleTemplateChange(selectedId) {
      console.log(selectedId)
      const selectedItem = this.template_data.find(item => item.id === selectedId)
      if (selectedItem) {
        console.log('选中的 item:', selectedItem)
        console.log('选中的 item:', selectedItem.project_param.delivery_setting)
        this.delivery_mode = selectedItem.project_param.delivery_mode
        this.form_data.budget_mode = selectedItem.project_param.delivery_setting.budget_mode
        this.form_data.budget = selectedItem.project_param.delivery_setting.budget
        // 根据 selectedItem 的值修改其他参数
      }
    },
    handleTemplateChange2(selectedId) {
      const selectedItem = this.template_data.find(item => item.id === selectedId)
      if (selectedItem) {
        console.log('选中的 item:', selectedItem)
        // 根据 selectedItem 的值修改其他参数
        this.form_data.someOtherField = selectedItem.someProperty
      }
    },
    showAccountDialog() {
      this.accountDialogVisible = true
    },

    // 应用搜索
    async queryAppSearch(query, row) {
      console.log(111111111122222223321321312312)
      if (row.account_id) {
        this.appLoading = true
        try {
          const res = await microApp({
            keyword: query,
            account_id: row.account_id,
            page: 1,
            page_size: 10
          })
          // 只更新当前行的应用选项
          this.$set(row, 'appOptions', res.data)
        } catch (error) {
          console.error('搜索应用失败', error)
          this.$set(row, 'appOptions', [])
        } finally {
          this.appLoading = false
        }
      } else {
        this.$set(row, 'appOptions', [])
      }
    },

    // 链接搜索
    async queryLinkSearch(query, row) {
      if (row.micro_app_id) {
        this.linkLoading = true
        try {
          const res = await copyv2urllist({
            remark: query,
            app_id: row.micro_app_id,
            page: 1,
            page_size: 10
          })
          // 只更新当前行的链接选项
          this.$set(row, 'linkOptions', res.data.list)
        } catch (error) {
          console.error('搜索链接失败', error)
          this.$set(row, 'linkOptions', [])
        } finally {
          this.linkLoading = false
        }
      } else {
        this.$set(row, 'linkOptions', [])
      }
    },
    handleAppSearch(row) {
      this.queryAppSearch('', row) // 空查询会返回默认结果
    },
    handleLinkSearch(row) {
      this.queryLinkSearch('', row) // 空查询会返回默认结果
    },
    handleLuoDiSearch(row) {
      this.queryLoDiYeSearch('', row) // 空查询会返回默认结果
    },
    handleTemplateSearch() {
      this.fetchUserList('')
    },
    // 落地页
    async queryLoDiYeSearch(query, row) {
      try {
        const res = await siteList({
          keyword: query,
          account_id: row.account_id,
          template_id: this.form_data.template_id,
          page: 1,
          page_size: 10
        })
        // 只更新当前行的链接选项
        this.$set(row, 'LuoDiOptions', res.data)
      } catch (error) {
        console.error('搜索链接失败', error)
        this.$set(row, 'LuoDiOptions', [])
      }
    },

    // 应用选择变化
    handleAppChange(selectedItem, row) {
      console.log(row, '和', selectedItem)
      if (selectedItem) {
        console.log(row.appOptions, 'app', selectedItem, 'item')
        const selectedItem2 = row.appOptions.find(item => item.instance_id === selectedItem)
        // 同时更新多个字段
        this.$set(row, 'micro_app_id', selectedItem2.app_id)
        this.$set(row, 'micro_app_instance_id', selectedItem2.instance_id)
        this.$set(row, 'micro_app_name', selectedItem2.name)
        // 可以继续添加其他需要同步的字段...
        this.$set(row, 'micro_app_url_id', null)
        this.$set(row, 'linkOptions', [])
      }
    },
    addAccountList(val) {
      console.log(val)
      this.all_accounts = [...new Set(val)]
      val.forEach(id => {
        if (!this.form_data.account_param.some(item => item.account_id === id)) {
          iseAccount({ account_id: id }).then(res => {
            res.data.push({
              'aweme_id': '',
              'aweme_name': '账户信息'
            })
            this.form_data.account_param.push({
              account_id: id,
              DouYinOptions: res.data
            })
          })
        }
      })
      this.accountDialogVisible = false
    },
    handleClose(val) {
      console.log(val)
      const index = this.form_data.account_param.findIndex(item => item.account_id === val.account_id)
      const index2 = this.all_accounts.findIndex(item => item === val.account_id)
      console.log('找到的索引:', index, index2) // 应该是数字

      if (index !== -1) {
        this.$delete(this.form_data.account_param, index)
        // 或者 this.form_data.account_param.splice(index, 1);
      }
      if (index2 !== -1) {
        this.$delete(this.all_accounts, index2)
      }
    }
  }
}
</script>

<style scoped>
.custom-label-form >>> .el-form-item__label {
  font-size: 16px;
  font-weight: bold; /* 可选 */
}
.line {
  height: 1px;
  width: 100%;
  background-color: #E6EBF2;
}
.form_item_box{
  padding: 20px 24px;
}
.container {
  display: flex;
  flex-wrap: wrap;
  padding-left: 20px;
  gap: 20px 100px; /* 行间距20px，列间距100px */
}

.label-with-input {
  flex: 0 0 calc((100% - 2 * 100px - 20px) / 3);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.seletime {
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  width: 2600px;
  gap: 4px;
}
.custom-upload-box {
  width: 50px;
  height: 50px;
  border: 1px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8c939d;
  font-size: 28px;
  cursor: pointer;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
}
.redsp {
  color: red;
}

.form-error-text {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  margin-top: 4px;
}
.is-error ::v-deep .el-input__inner,
.is-error ::v-deep .el-select .el-input__inner {
  border-color: #f56c6c !important;
  color: #A3AAB3 !important;
  background-color: #FFECE8 !important;
}
.checkbox-grid {
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px; /* 两列间隔 */
  row-gap: 12px;     /* 行间隔 */
}

.checkbox-item {
  width: calc(43% - 10px); /* 两列布局 - 控制每个元素占一半宽度减间距 */
  display: flex;
  align-items: center;
}
.image-preview .preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-preview .delete-btn {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 18px;
  height: 18px;
  background: red;
  color: white;
  font-size: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.button-box-itemfoot{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.ad_img {
  width: 118px;height: 30px;
}
::v-deep .el-form-item {
  margin-bottom: 0; /* 你想设置的新值 */
}
::v-deep .el-input:not(.el-date-editor) .el-input__inner {
  height: 36px;             /* 设置输入框高度 */
  font-size: 14px;          /* 字体大小 */
  border-radius: 6px;       /* 圆角 */
  padding: 0 12px;          /* 内边距 */
  background-color: #F2F3F5;/* 背景色 */
  border: 0 solid #ccc;   /* 边框 */
  color:  #000;              /* 字体颜色 */
  box-shadow: none;         /* 去掉聚焦时阴影 */
}

/* 所有 radio button 的基础样式 */
::v-deep .el-radio-button__inner {
  background-color: #f2f2f2 !important;
  color: #666666 !important;
  border: none !important;
  padding: 10px 20px;
  font-size: 14px;
  transition: all 0.2s;
  box-shadow: none !important;
}

/* 选中状态 */
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #ffffff !important;
  color: #165DFF !important;
  border: 1px solid  #165DFF !important;
  box-shadow: none !important;
}

/* hover 效果（可选） */
::v-deep .el-radio-button__inner:hover {
  color: #409EFF;
}

/* 去除左右连接边框 */
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-left: none;
}

/deep/ .el-checkbox__inner {
  width: 18px !important;
  height: 18px !important;
  border-radius: 3px;
}
/deep/ .el-checkbox__inner::after {
  /* 调整位置 */
  top: 2px !important;
  left: 5px !important;
  /* 控制“√”的形状 */
  width: 4px !important;
  height: 8px !important;
  border-width: 2px !important;
}

.checkbox-grid /deep/ .el-checkbox.is-checked .el-checkbox__label {
  color: inherit !important;
  font-weight: normal !important;
}
/* hover 时添加边框 */
::v-deep .el-input__inner:hover {
  border: 1px solid #165dff !important; /* 自定义颜色 */
}
.is-error ::v-deep .el-input__inner:hover {
  border-color: #d93025 !important; /* 更深一点的红色 */
}
::v-deep .el-input__inner:focus {
  background-color: #ffffff !important;
  border: 1px solid #165dff !important;
}
.is-error ::v-deep .el-input__inner:focus {
  border-color: #d93025 !important; /* 更深一点的红色 */
}
::v-deep .el-dialog {
  border-radius: 16px;
}
::v-deep .el-dialog__body {
  padding: 24px 20px;
}
::v-deep .el-image-viewer__close {
  color: #fff !important;
}

::v-deep .el-image-viewer__close .el-icon {
  color: #fff !important;
  fill: #fff !important;
}

::v-deep .el-image-viewer__close svg {
  fill: #fff !important;
}
/* 修复 el-input-number 按钮间隔问题 */
.custom-input-number ::v-deep .el-input-number__increase,
.custom-input-number ::v-deep .el-input-number__decrease {
  line-height: 0; /* 移除默认的行高 */
  border: none;   /* 移除边框 */
  margin: 0;      /* 移除外边距 */
}

.custom-input-number ::v-deep .el-input-number__increase {
  border-bottom: 1px solid #dcdfe6; /* 添加分隔线 */
}

/* 确保按钮容器没有额外间距 */
.custom-input-number ::v-deep .el-input-number__decrease,
.custom-input-number ::v-deep .el-input-number__increase {
  height: 50%; /* 每个按钮占一半高度 */
  display: flex;
  align-items: center;
  justify-content: center;
}
.action-btn {
  cursor: pointer;
  color: #409EFF;
  margin: 0 10px;
  transition: color .2s;
}
.action-btn:hover {
  opacity: .8;
}
</style>
